/**
 * マニフェスト管理 運搬終了報告
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/completion_reports`

const manifest_completion_report = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 運搬終了報告初期情報
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    show ({ commit }, { params }) {
      const api_path = `${API_PATH}/report_items`
      return new Promise((resolve) => {
        Vue.$http.post(api_path, params).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     * 運搬終了報告登録
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
}

export default manifest_completion_report
